(ns renolit-roofing-service.layout.form.error
  (:require [malli.core :as m]
            [malli.error :as me]
            [malli.util :as mu]
            [medley.core :as medley]
            [re-frame.core :as rf]
            [renolit-roofing-service.localization :refer [t]]))

(rf/reg-sub
 ::errors
 (fn [db [_ context path]]
   (get-in db (concat [:form-errors context] path))))

(rf/reg-event-db
 ::register-errors
 (fn [db [_ context errors]]
   (assoc-in db [:form-errors context] errors)))

(rf/reg-event-db
 ::clear-errors
 (fn [db [_ context]]
   (update db :form-errors dissoc context)))

(defn- nil-required-map-value?
  [schema malli-error]
  (when (nil? (:value malli-error))
    (let [parent-schema (mu/get-in schema (butlast (:path malli-error)))]
      (when (= :map (m/type parent-schema))
        (let [child-key (last (:path malli-error))
              child (medley/find-first #(= child-key (first %)) (m/children parent-schema))
              optional? (:optional (second child))]
          (not optional?))))))

(defn- fallback-error-builder
  [schema malli-error]
  (if (nil-required-map-value? schema malli-error)
    {:reason :missing-key}
    {:reason :invalid}))

(def ^:private error-builders
  {:malli.core/missing-key (constantly {:reason :missing-key})
   :malli.core/limits (fn [{:keys [schema]}]
                        {:reason :length
                         :limits (select-keys (m/properties schema) [:min :max])})
   :int (fn [{:keys [schema pred value]}]
          (if (pred value)
            {:reason :invalid}
            {:reason :size
             :limits (select-keys (m/properties schema) [:min :max])}))
   :double (fn [{:keys [schema pred value]}]
             (if (pred value)
               {:reason :invalid}
               {:reason :size
                :limits (select-keys (m/properties schema) [:min :max])}))})

(defn- malli-error->error
  [schema malli-error]
  (if-let [error-builder (get error-builders (:type malli-error))]
    (error-builder malli-error)
    (fallback-error-builder schema malli-error)))

(defn check-errors
  [schema data]
  (->
   (m/explain schema data)
   (me/humanize {:wrap (partial malli-error->error schema)})))

(defn form-error->msg
  [{:keys [reason]}]
  (t [(keyword "form.errors.reason" (name reason))]))

(defn form-item-errors
  [form-errors]
  [:div.form-item__errors
   (doall
    (for [form-error (distinct form-errors)]
      ^{:key (hash form-error)}
      [:span (form-error->msg form-error)]))])

(defn error-label
  [form-errors]
  (let [{:keys [message-transl-kw reason]} (first form-errors)]
    [:label.form-item__error-label (t [(or message-transl-kw (keyword "form.error.reason" (name reason)))])]))
